import ArrowLeft from "../../assets/icons/Arrow/ArrowLeft";
import Carousel from "../../components/Carousel/Carousel";
import { addCartItem } from "../../services/cartShoppingService";
import {
  getProduct,
  getProductNotice,
  getProducts,
} from "../../services/productService";
import { getUser } from "../../services/userService";
import { refreshAccessToken } from "../../store/slice/authSlice";
import { AppDispatch, RootState } from "../../store/store";
import { getPrice } from "../../utils/getPrice";
import ProductCarousel from "../Homepage/components/ProductCarousel/ProductCarousel";
import "./Product.scss";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const Product = () => {
  const { category, subcategory, idproduct } = useParams();
  const { categories, products } = useSelector(
    (state: RootState) => state.products
  );
  const dispatch = useDispatch<AppDispatch>();
  const [productQuantity, setProductQuantity] = useState(1);
  const { categoryName, subcategoryName } = useMemo(() => {
    const cat = categories.find((ca) => ca.code === category);
    const subcat = cat?.subcategories.find((ca) => ca.code === subcategory);
    return { categoryName: cat?.name, subcategoryName: subcat?.name };
  }, [category, subcategory, categories]);

  const handleNotice = (
    e: React.MouseEvent<HTMLAnchorElement>,
    type: "fs" | "ft"
  ) => {
    e.preventDefault();
    products.targetItem.item?.Code &&
      dispatch(
        getProductNotice({ type, code: products.targetItem.item?.Code })
      ).then((value: any) => {
        window.open(value.payload.url, "_blank");
      });
  };

  useEffect(() => {
    if (
      (idproduct && !products.targetItem?.item) ||
      idproduct !== products.targetItem?.item?.Code
    ) {
      idproduct && dispatch(getProduct({ code: idproduct }));
    }
  }, [idproduct, dispatch, products.items?.length, products.targetItem?.item]);

  useEffect(() => {
    products.items.length === 0 &&
      dispatch(
        getProducts({
          category: products.targetItem.item?.Category?.code,
          subcategory: products.targetItem.item?.SubCategory?.code,
        })
      );
  }, [
    dispatch,
    products.items?.length,
    products.targetItem?.item?.Category?.code,
    products.targetItem?.item?.SubCategory?.code,
  ]);

  const { user } = useSelector((state: RootState) => state.user);
  const { access_token } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (access_token && !user?.id) {
      dispatch(getUser(access_token));
    }
  }, [user, access_token, dispatch]);

  useEffect(() => {
    dispatch(refreshAccessToken());
  }, [dispatch]);

  const navigate = useNavigate();

  const addProductToCart = () => {
    if (products.targetItem?.item?.Code) {
      dispatch(
        addCartItem({
          productCode: products.targetItem?.item.Code,
          quantity: productQuantity,
        })
      );
    }
  };

  return (
    <div className="product-container">
      <div id="path">
        <div onClick={() => navigate(`/category-product/${category}`)}>
          <p>{categoryName?.toUpperCase()}</p>
        </div>
        <p>/</p>
        <div
          onClick={() =>
            navigate(`/category-product/${category}/${subcategory}`)
          }
        >
          <p>{subcategoryName?.toUpperCase()}</p>
        </div>
        <p>/</p>
        <p id="active">
          {products.targetItem?.item?.Designation?.toUpperCase()}
        </p>
      </div>
      <div id="path-mobile">
        <ArrowLeft
          onClick={() =>
            navigate(`/category-product/${category}/${subcategory}`)
          }
        />
        <div id="active">
          {products.targetItem?.item?.Designation?.toUpperCase()}
        </div>
      </div>
      <div className="product-info-page">
        <div>
          <Carousel
            data={[
              {
                image: products.targetItem?.item?.ImageUrl,
                name: products.targetItem?.item?.Designation,
              },
            ]}
          />
        </div>
        <div>
          <h1>{products.targetItem?.item?.Designation}</h1>
          <div className="info-pdt">
            <div>
              <p id="cond">Vendu en conditionnement</p>
              <p id="ref-id">
                Référence {products.targetItem?.item?.Reference}
              </p>
            </div>
            {/* <div id="labels">
              <div>
                <img src="/images/label/Logo_Ecolabel.png" alt="eco" />
              </div>
              <div>
                <img
                  src="/images/label/fabrique-en-france.png"
                  alt="made in french"
                />
              </div>
            </div> */}
          </div>
          <div id="price">
            {/* <span id="old">X,XX €</span> */}
            <span id="new-price">
              {getPrice(products.targetItem?.item?.PrixHT, user?.discountRate)
                .toString()
                .replace(".", ",")}
              € HT
            </span>
          </div>
          <div id="panier">
            <input
              type="number"
              min={0}
              defaultValue={productQuantity}
              value={productQuantity}
              onChange={(e) => setProductQuantity(Number(e.target.value))}
            />
            <button onClick={addProductToCart}>Ajouter au panier</button>
          </div>
          {/* ) : (
            <button
              className={
                products?.targetItem?.item?.StockQuantity &&
                products?.targetItem?.item?.StockQuantity > 0
                  ? ""
                  : "out"
              }
            >
              Épuisé
            </button>
          )} */}
          <div id="fiches">
            {products.targetItem?.item?.FTFilePath !== "" && (
              <a
                onClick={(e) => handleNotice(e, "ft")}
                href={products.targetItem?.noticeFT}
                target="_blank"
                rel="noreferrer"
              >
                <button>Fiche technique</button>
              </a>
            )}
            {products.targetItem?.item?.FSFilePath !== "" && (
              <a
                className="fs"
                onClick={(e) => handleNotice(e, "fs")}
                href={products.targetItem?.noticeFS}
                target="_blank"
                rel="noreferrer"
              >
                <button>Fiche de sécurité</button>
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="more-product">
        <div className="separator" />
        <h3 id="title">Découvrez aussi</h3>
        <ProductCarousel
          products={products.items
            ?.slice(0, 10)
            .filter((item) => item.Code !== products.targetItem?.item?.Code)}
          type="secondary"
          displayRef={false}
        />
      </div>
    </div>
  );
};

export default Product;
